export const EMPTY_STATE_ICONS = {
	addCandidate: '/ats/icons/empty-state/add-candidate.png',
	noResults: '/ats/icons/empty-state/no-results.png',
	noResultsCandidates: '/ats/icons/empty-state/no-results-candidates.svg',
	noResultsJobs: '/ats/icons/empty-state/no-results-jobs.svg',
	noResultsClients: '/ats/icons/empty-state/no-results-clients.svg',
	client: '/ats/icons/empty-state/clients.svg',
	allCaughtUp: '/ats/icons/empty-state/all-caught-up.png',
	job: '/ats/icons/empty-state/job.png',
	sheet: '/ats/icons/empty-state/sheet.png',
	candidate: '/ats/icons/empty-state/candidate.png',
	internalProcess: '/ats/icons/empty-state/internal-process.svg',
	inviteTalentNetwork: '/ats/icons/empty-state/invite-talent-network.svg',
	jobHistoryEmpty: '/ats/icons/empty-state/job-history-empty.svg',
	changelogEmpty: '/ats/icons/empty-state/changelog-empty.svg'
};
